import { ECardType } from '__generated__/globalTypes';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';
import { uniq } from 'lodash';

const importKeyColumn = `Nom de l'entreprise`;

const CATEGORIES = {
    'Banking & Asset Management': '09e113f3-766e-4b07-b6d1-22da91cf06a6',
    'Financial Analysis and Audit': '0046487c-5621-4d43-b121-c209755ec9d4',
    'Global Supply Chain Management': 'a7f43870-7b57-4705-b0f7-7f3915cf99e3',
    'Intrapreneurship and Management of Innovation Projects':
        '724959a6-9d93-4f29-826e-a66bc7682628',
    'Supply Chain Management & Business Analytics': '1422a2ce-a322-45ac-a91a-3cfccf616fe9',
    'Financial Engineering': 'a631c335-be13-424b-8d08-5bd720102d0d',
    'Sustainable Performance Management': '7bc81a76-9ee2-4cb4-8e6d-06fb4bff6a0e',
    'Digital Business (HEC - Faculté des sciences appliquées)':
        'c6aec7b6-f2dc-4660-837f-832cc743e491',
    'Industrial & Business Engineering (HEC - Helmo Gramme)':
        'ed84ee81-3afa-41d3-90bb-70202d570a5e',
    'Droit-Gestion (HEC - Faculté de droit)': 'b28c38ec-fa59-41f8-93f6-18086377d31e',
    'International Strategic Marketing': 'edbd9fdd-7a83-42a2-8181-986915c660f0',
    'Management des Entreprises Sociales et Durables': 'e0a663e5-edb8-4d40-8b18-d800fbe2b073',
    'Economic Analysis and Policy': 'be3a4993-0c1e-40b7-a1e0-d470f51b4a10',
    'Macroeconomics & Finance': 'cee0c008-7259-48ce-8872-5ba90338e60a',
    'Stratégie et Management des Ressources Humaines (HEC - Faculté des Sciences Sociales)':
        '5ebde136-a43a-466c-805b-0ade0947e618',
    'Droit-Gestion (HEC – Faculté de droit)': 'ce6e08da-5e5e-4ffc-aefd-04a2326dd962',
    'Digital Business (HEC – Faculté des sciences appliquées)':
        '93069dab-cbb5-41ee-93ce-1ce84348e405'
};

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    const imageFormValue = row[`Logo d'entreprise`];
    const imageId = imageFormValue.trim().startsWith('https://drive.google.com/open?id=')
        ? imageFormValue
              .trim()
              .replace('https://drive.google.com/open?id=', '')
              .replace('&usp=drive_copy', '')
        : null;
    const imageUrl = imageId ? 'https://drive.google.com/uc?id=' + imageId : null;

    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row[importKeyColumn],
            header: {
                title: row[`Nom de l'entreprise`],
                text: row[`Description de l'entreprise (maximum 100 caractères)`],
                imageUrl
            }
        },
        cards: []
    };

    if (row['URL internet']) {
        mutationPayload.cards.push({
            type: ECardType.LINK,
            links: [
                {
                    title: 'Website',
                    url: row['URL internet']
                }
            ]
        });
    }

    if (row['Adresse']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Adresse',
                description: row['Adresse']
            }
        });
    }

    console.log(row['What are you looking for in students? (Max two paragraphs)']);

    if (row['What do you offer students?']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'What do you offer students?',
                description: row['What do you offer students?']
                    .split(';')
                    .map((e) => e.trim())
                    .filter(Boolean)
                    .join('\n')
            }
        });
    }

    if (row['Profil(s) recherché(s)']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Profil(s) recherché(s)',
                description: row['Profil(s) recherché(s)']
                    .split(',')
                    .map((e) => e.trim())
                    .filter(Boolean)
                    .join('\n')
            }
        });
    }

    if (row['Poste(s) à pourvoir']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Poste(s) à pourvoir',
                description: row['Poste(s) à pourvoir']
            }
        });
    }

    if (row['Stages disponibles']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Stages disponibles',
                description: row['Stages disponibles']
            }
        });
    }

    if (row['Finalité(s) recherchée(s)']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Finalité(s) recherchée(s)',
                description: row['Finalité(s) recherchée(s)']
                    .split(',')
                    .map((e) => e.trim())
                    .filter(Boolean)
                    .join('\n')
            }
        });
    }

    const categories = row['Finalité(s) recherchée(s)']
        .replace('"', '')
        .split(',')
        .map((e) => e.trim())
        .map((e) => CATEGORIES[e])
        .filter(Boolean);
    mutationPayload.addToCategoriesId = uniq(categories);

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row[importKeyColumn]?.toLowerCase();
}

export const liege2024ImportMethods = { duplicateChecker, parser, importKeyColumn };
